/**
 * Legacy module shell — kept so AngularJS modules that declare
 * 'acme.common.service.ticketConfig' as a dependency keep bootstrapping.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/ticket-config/ticket-config.service.ts
 *
 * Registered with AngularJS via downgradeInjectable in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * so any $inject = ['TicketConfigService'] resolves to the Angular 18 class.
 */
angular.module('acme.common.service.ticketConfig', []);
